/**
 * Collapsible desktop controls. Keep the garden visible during play;
 * the native disclosure remains keyboard accessible. Hidden on touch.
 */
import "./keys.css";
import { mount } from "./dom.js";

export function mountKeys() {
  return mount(`
<details id="keys" class="panel">
  <summary>Controls</summary>
  <div class="key-grid">
  <b>W A S D</b><span>prowl</span>
  <b>Shift</b><span>run</span>
  <b>Space</b><span>jump</span>
  <b>hold Space</b><span>gather a pounce &mdash; half again as high</span>
  <b>+ W A S D</b><span>aim the leap</span>
  <b>hold Click</b><span>claws out &mdash; cling to wood</span>
  <b>+ W S</b><span>scrabble up or down</span>
  <b>+ Space</b><span>leap up the wall</span>
  <b>Mouse</b><span>look around</span>
  <b>C</b><span>sit</span>
  <b>V</b><span>meow</span>
  <b>Ctrl</b><span>stalk</span>
  <b>F</b><span>claw swipe</span>
  <b>M</b><span>purr on / off</span>
  <b>T</b><span>say something</span>
  <b>B</b><span>build your own cat</span>
  <b>R</b><span>back to the front lawn</span>
  </div>
</details>`);
}
